export const MUTATION_KEYS = {
  MUTATION_KEYS_ADD_TO_CART: "MUTATION_KEYS_ADD_TO_CART",
  MUTATION_KEY_CREATE_PAYMENT: "MUTATION_KEY_CREATE_PAYMENT",
  MUTATION_KEY_PATCH_PAYMENT: "MUTATION_KEY_PATCH_PAYMENT"
};
